@if (affiliates$ | async; as affiliates) {
  @if (affiliates.length) {
    <div id="grayBg">
      <!-- Desktop Grid Layout -->
      @if (!isMobile) {
        <div class="container searchCardBody mt-5 pb-5">
          <div class="row row-cols-3 g-4">
            @for (affiliate of affiliates; track affiliate) {
              <div class="col">
                <div class="card h-100 border-0 searchCard">
                  <a [href]="affiliate.hrefLink" target="_blank" class="text-center" aria-label="Affiliate Link">
                    <img [src]="affiliate.imageUrl" class="card-img-top mx-auto logoImg" [alt]="affiliate.name + ' logo'" />
                  </a>
                  <div class="card-body mt-4 pb-5">
                    <h2 class="card-title">
                      {{ affiliate.name }}
                    </h2>
                    <p class="card-text pb-4">
                      {{ affiliate.description }}
                    </p>
                  </div>
                  <div class="d-flex align-items-end mb-5 px-4">
                    <a type="button" class="btn btn-light" [href]="affiliate.hrefLink" role="button" target="_blank"
                      [attr.aria-label]="affiliate.name + ' Link'">
                      {{ affiliate.hrefText }}
                      <fa-icon [icon]="faExternalLink"></fa-icon>
                    </a>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <!-- Mobile/Tablet Carousel Layout -->
      @if (isMobile) {
        <div id="mobileCarousel" class="carousel slide" data-ride="carousel">
          <div class="container searchCardBody mt-5 pb-5">
            <div class="carousel-inner" role="option">
              @for (affiliate of affiliates; track affiliate; let i = $index) {
                <div [ngClass]="{'carousel-item': true, 'active': i === 0}">
                  <div class="row">
                    <div class="col">
                      <div class="card h-100 border-0 searchCard">
                        <a [href]="affiliate.hrefLink" target="_blank" class="text-center" aria-label="Affiliate Link">
                          <img [src]="affiliate.imageUrl" class="card-img-top mx-auto logoImg" [alt]="affiliate.name + ' logo'" />
                        </a>
                        <div class="card-body mt-4 pb-5">
                          <h2 class="card-title">{{ affiliate.name }}</h2>
                          <p class="card-text pb-4">{{ affiliate.description }}</p>
                        </div>
                        <div class="d-flex align-items-end mb-5 px-4">
                          <a type="button" class="btn btn-light" [href]="affiliate.hrefLink" role="button" target="_blank"
                            [attr.aria-label]="affiliate.name + ' Link'">
                            {{ affiliate.hrefText }}
                            <fa-icon [icon]="faExternalLink"></fa-icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
            <!-- Carousel Controls -->
            <button class="carousel-control-prev" type="button" data-bs-target="#mobileCarousel" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#mobileCarousel" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      }
    </div>
  }
}